import { Button, Col, Container, Modal, Row } from "react-bootstrap";
import Loader from "../../../../common/Loader";
import Snackbar from "../../../../common/Snackbar";
import { useEffect, useState } from "react";
import MultilineTextBox from "../../../../common/MultilineTextBox";
import AccordionComponent from "../../../../common/Accordion";
import InvoiceResolveDataTable from "./InvoiceResolveDataTable";
import {
  INVOICE_RESOLVE_LINEITEM_EXCEPTIONS,
  INVOICE_RESOLVE_MISSING_LINE_COUNT,
  INVOICE_RESOLVE_MISSING_PAGE_COUNT,
  INVOICE_RESOLVE_MULTIPLE_CONGF_SETUP,
} from "../actions/constants";
import { INVOICE_STATUS } from "../../../../common/Constant";
import {
  getInvoiceCaseNotes,
  getStandardChargeNotesDetails,
  updateInvoiceResolutionPageLines,
} from "../../../../services/InvoiceAPI";

interface ResolveProps {
  showDrawer: boolean;
  onClose: (action: any) => void;
  selectedRows: any;
}

const multipleLevelrows = [
  {
    id: 1,
    level: "Case Level",
    appliedRate: "checked",
    userRole: "Mr. Alan (Historian)",
    rateType: "Fixed",
    currency: "$",
    effectiveFrom: "19/02/2026",
    effectiveTo: "19/02/2026",
    uploadedOnBy: "01/01/2026 12:00 AM | Mr. Tom (Case Manager)",
  },
  {
    id: 2,
    level: "Case Level",
    appliedRate: "A",
    userRole: "Mr. Alan (Historian)",
    rateType: "Fixed",
    currency: "$",
    effectiveFrom: "19/02/2026",
    effectiveTo: "19/02/2026",
    uploadedOnBy: "01/01/2026 12:00 AM | Mr. Tom (Case Manager)",
  },
  {
    id: 4,
    level: "Case Level",
    appliedRate: "",
    userRole: "Mr. Alan (Historian)",
    rateType: "Fixed",
    currency: "$",
    effectiveFrom: "19/02/2026",
    effectiveTo: "19/02/2026",
    uploadedOnBy: "01/01/2026 12:00 AM | Mr. Tom (Case Manager)",
  },
];

const InvoiceResolve: React.FC<ResolveProps> = ({
  showDrawer,
  onClose,
  selectedRows,
}) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [error, setError] = useState("");
  const [comments, setComments] = useState<string>("");
  const [activeKey, setActiveKey] = useState<string | null>("0");
  const [tableData, setTableData] = useState<any[]>([]);
  const [initialTableData, setInitialTableData] = useState<any[]>([]);
  const [showModalNew, setShowModalNew] = useState<boolean>(false);
  const status = selectedRows?.[0]?.invoiceLineItemStatus || "";
  const item = selectedRows?.[0];

  const fetchNotesDetails = async () => {
    let notesDetails = [];

    if (item?.subjectQmeScheduleID) {
      notesDetails = await getInvoiceCaseNotes(
        item.subjectQmeScheduleID,
        item.invoiceLineItemId,
      );

      setTableData(notesDetails?.[0]?.subjectQmeScheduleId ? notesDetails : []);
      setInitialTableData(
        notesDetails?.[0]?.subjectQmeScheduleId ? notesDetails : [],
      );
    } else {
      notesDetails = await getStandardChargeNotesDetails(item?.caseInfoId);
      setTableData(notesDetails?.[0]?.noteId ? notesDetails : []);
      setInitialTableData(notesDetails?.[0]?.noteId ? notesDetails : []);
    }
  };

  const getUploadInfoParts = (value: string = "") => {
    const [dateTime = "", userInfo = ""] = value?.split(" | ");
    return { dateTime, userInfo };
  };

  const buildRowData = (item: any, status: string) => {
    const { dateTime, userInfo } = getUploadInfoParts(item.uploadInformation);
    const examType = item.appointmentTypeName || "";

    return {
      id: item.invoiceLineItemId,
      userRole: userInfo,
      examType: examType,
      userInfoWithExamType:
        userInfo && examType
          ? `${userInfo} - [${examType}]`
          : userInfo
            ? userInfo
            : examType
              ? `[${examType}]`
              : "",

      ...(status === INVOICE_STATUS.EXCEPTION_MISSING_LINE_COUNT
        ? {
            no_of_Lines_missingLineCount: Number(item.noOfLines),
            no_Of_MissingPages: Number(item.noOfPages),
          }
        : {
            no_of_Lines: item.noOfLines,
            no_Of_Pages: Number(item.noOfPages),
          }),

      rateType: item.rateType,
      uploadedOn: dateTime,
      rate: item.rate,
      invoicestatus: item.invoiceLineItemStatus,
      amount: item.amount,
    };
  };

  useEffect(() => {
    if (!item) return;

    if (status === INVOICE_STATUS.EXCEPTION_NO_BILLING_CONFIG) {
      fetchNotesDetails();
    }

    if (
      status === INVOICE_STATUS.EXCEPTION_MISSING_PAGE_COUNT ||
      status === INVOICE_STATUS.EXCEPTION_MISSING_LINE_COUNT
    ) {
      const data = [buildRowData(item, status)];
      setTableData(data);
      setInitialTableData(data);
    }
  }, [selectedRows, status, item]);

  const resolveConfigMap: any = {
    [INVOICE_STATUS.EXCEPTION_MISSING_PAGE_COUNT]: {
      headers: INVOICE_RESOLVE_MISSING_PAGE_COUNT,
      data: tableData,
      isGroupLevel: false,
      isCheckbox: false,
    },

    [INVOICE_STATUS.EXCEPTION_MISSING_LINE_COUNT]: {
      headers: INVOICE_RESOLVE_MISSING_LINE_COUNT,
      data: tableData,
      isGroupLevel: false,
      isCheckbox: false,
    },

    [INVOICE_STATUS.EXCEPTION_NO_BILLING_CONFIG]: {
      headers: INVOICE_RESOLVE_LINEITEM_EXCEPTIONS,
      data: tableData,
      isGroupLevel: false,
      isCheckbox: false,
    },

    [INVOICE_STATUS.EXCEPTION_MULTIPLE_BILLING_CONFIG]: {
      headers: INVOICE_RESOLVE_MULTIPLE_CONGF_SETUP,
      data: multipleLevelrows,
      isGroupLevel: true,
      isCheckbox: true,
    },
  };

  const currentConfig =
    resolveConfigMap[status] ||
    resolveConfigMap[INVOICE_STATUS.EXCEPTION_MISSING_PAGE_COUNT];

  const renderAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
        title: (
          <div className="d-flex justify-content-between align-items-center w-100">
            <div>{item.title}</div>
            <div>{initialTableData[0]?.userInfoWithExamType || ""}</div>
          </div>
        ),
      }))}
      activeKey={activeKey}
      onSelect={(key) => setActiveKey(key as string)}
    />
  );

  const handleDataChange = (updatedRows: any) => {
    setTableData(updatedRows);
  };

  const handleCancelButton = () => {
    setShowModalNew(true);
  };

  const handleCloseModalNew = () => {
    setShowModalNew(false);
    setComments("");
    setTableData(initialTableData);
  };

  const handleConfirmCancelButton = () => {
    setShowModalNew(false);
    setSnackbarOpen(false);
    setSnackbarMessage("");
  };

  const validation = () => {
    const errors = [];

    if (
      !tableData[0]?.no_Of_Pages &&
      status === INVOICE_STATUS.EXCEPTION_MISSING_PAGE_COUNT
    ) {
      errors.push("No. of Pages is mandatory.");
    }

    if (
      !tableData[0]?.no_of_Lines_missingLineCount &&
      status === INVOICE_STATUS.EXCEPTION_MISSING_LINE_COUNT
    ) {
      errors.push("No. of Lines is mandatory.");
    }

    if (!comments) {
      errors.push("Reason is mandatory.");
    }

    if (errors?.length > 0) {
      setSnackbarMessage(errors.join("\n"));
      setSnackbarOpen(true);
      setError("error");
      return false;
    }

    return true;
  };

  const handleSubmit = async () => {
    try {
      if (!validation()) return;
      setLoading(true);
      const itemTableData = tableData[0];
      const payload = {
        invoiceLineItemId: itemTableData?.id,
        ...(itemTableData.invoicestatus ===
        INVOICE_STATUS.EXCEPTION_MISSING_LINE_COUNT
          ? { noOfLines: Number(itemTableData?.no_of_Lines_missingLineCount) }
          : { noOfPages: Number(itemTableData?.no_Of_Pages) }),
        comments: comments || "",
      };
      const response = await updateInvoiceResolutionPageLines(payload);
      if (response?.isSuccess) {
        setSnackbarMessage("Invoice line item resolved successfully.");
        setError("success");
        setSnackbarOpen(true);
        await new Promise((resolve) => setTimeout(resolve, 1500));
        onClose("Save");
      } else {
        setSnackbarMessage(
          response.message || "Failed to update invoice line item resolve.",
        );
        setError("error");
        setSnackbarOpen(true);
      }
    } catch (error: any) {
      setSnackbarMessage(error.message);
      setError("error");
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Container fluid className="px-1">
        <Loader isLoading={loading} />
        <Snackbar
          open={snackbarOpen}
          message={snackbarMessage}
          onClose={() => setSnackbarOpen(false)}
          severity={error}
        />
        {renderAccordion([
          {
            title: "Exception Details",
            content: (
              <div>
                <>
                  <InvoiceResolveDataTable
                    headers={currentConfig.headers}
                    rows={currentConfig.data}
                    onDataChange={handleDataChange}
                    isGroupLevel={currentConfig.isGroupLevel}
                    isCheckbox={currentConfig.isCheckbox}
                  />
                </>
                <Row>
                  <Col
                    sm={12}
                    className="mt-3 notemultiline notemultilinerushnote mb-3"
                  >
                    <MultilineTextBox
                      label="Reason"
                      style={{ minHeight: "100px" }}
                      name="comments"
                      value={comments}
                      onChange={(e) => {
                        let value = e.target.value;
                        if (value.startsWith(" ")) return;
                        value = value?.trimStart();
                        value = value.replace(/ {2,}/g, " ");
                        setComments(value);
                      }}
                      maxLength={500}
                    />
                  </Col>
                </Row>
              </div>
            ),
          },
        ])}

        <Row id="team-form-buttons" className="bottom-fixed-btn">
          <Col md={6} className="d-flex justify-content-start mb-2 "></Col>
          <Col md={6} className="d-flex justify-content-end mb-2 px-0 pe-3">
            <Button
              variant="outline-info"
              className="d-flex align-items-center"
              onClick={handleCancelButton}
            >
              <span className="material-icons mr-2">close</span> Cancel
            </Button>
            <Button
              variant="primary"
              className="ms-3 d-flex align-items-center"
              onClick={handleSubmit}
            >
              <span className="material-icons mx-1">check</span> Confirm &
              Resolve
            </Button>
          </Col>
        </Row>
      </Container>
      <Modal show={showModalNew} onHide={handleCloseModalNew}>
        <Modal.Body className="fw-bold text-left modelheading ">
          <div>Are you sure you want to cancel?</div>
        </Modal.Body>
        <Modal.Footer className="border-top d-flex justify-content-end">
          <Button
            variant="outline-info"
            className="d-flex align-items-end"
            onClick={handleCloseModalNew}
          >
            <span className="material-icons mr-2">close</span> Cancel
          </Button>
          <Button
            onClick={handleConfirmCancelButton}
            variant="primary"
            className="ms-3 d-flex align-items-center"
          >
            <span className="material-icons mx-1">check</span> Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default InvoiceResolve;
